import { Component } from '@angular/core';
import { MdcService } from 'src/app/shared/mdc/mdc.service';

@Component({
  selector: 'app-step-section-iii',
  templateUrl: './step-section-iii.component.html',
})
export class StepSectionIIIComponent {

  constructor(public mdcService: MdcService) { }

  ngOnInit() {
    this.onNgSelectChange()
  }

  onNgSelectChange() {
    const valor = this.mdcService.formData.mdc_24;
    if (valor !== null && valor !== undefined && valor !== null) {
      $('#mdc_24_hidden').val(valor).trigger('input');
    }
  }
}
